import cn from 'classnames';
import React from 'react';
import styles from './body1.module.scss';

export interface Body1Props {
  bold?: boolean;
  color?: string;
  children?: any;
  className?: string;
  hasIcon?: boolean;
  id?: string;
}

const Body1: React.FC<Body1Props> = ({
  children,
  className,
  color,
  bold = false,
  hasIcon,
  id = null
}) => (
  <p
    id={id}
    className={cn(
      styles.body1,
      styles[color],
      {
        [styles.bold]: bold
      },
      className,
      {
        [styles.icon]: hasIcon
      }
    )}
  >
    {children}
  </p>
);

export default Body1;
